import {toggleModal} from "./toggleModalActions";

export const getCommunitySensorsPending = () => {
    return {
        type: 'GET_COMMUNITY_SENSORS_PENDING'
    }
};

export const getCommunitySensorsSuccess = (sensors, page, pageCount, itemsCount) => {
    return {
        type: 'GET_COMMUNITY_SENSORS_SUCCESS',
        sensors,
        page,
        pageCount,
        itemsCount
    }
};

export const getCommunitySensorsError = error => {
    return {
        type: 'GET_COMMUNITY_SENSORS_ERROR',
        error: error
    }
};

export const addCommunitySensorSuccess = () => {
    return {
        type: 'ADD_COMMUNITY_SENSOR_SUCCESS'
    }
};

export const addCommunitySensorError = error => {
    return {
        type: 'ADD_COMMUNITY_SENSOR_ERROR',
        error: error
    }
};

export const getCommunitySensors = (page, numberPerPage, filter, userId, search) => {

    const pageNumber = page ? page : 1;
    const filterValue = filter ? filter : 'ALL';
    const userIdParam = userId ? `user_id=${userId}&` : '';
    const searchParam = search ? `search_query=${search}&` : '';
    const numberOfRecords = numberPerPage ? numberPerPage : 3;

    return dispatch => {
        dispatch(getCommunitySensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/community_sensor_list?${userIdParam}${searchParam}page=${pageNumber}&number_on_page=${numberOfRecords}&filter=${filterValue}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getCommunitySensorsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getCommunitySensorsSuccess(res.sensors, res.page, res.pageCount, res.itemsCount))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectCommunitySensor = (sensor, page) => {
    return {
        type: 'SELECT_COMMUNITY_SENSOR',
        selected: { sensor: sensor, page }
    };
};

export const setCommunitySensorsFilters = filters => {
    return {
        type: 'SET_COMMUNITY_SENSORS_FILTERS',
        filters: filters
    }
};

export const addCommunitySensor = sensorData => {
    return dispatch => {
        dispatch(getCommunitySensorsPending());

        fetch(`${process.env.REACT_APP_API_URL}/panel/community_data/create_community_sensor`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(sensorData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addCommunitySensorSuccess());
                    dispatch(toggleModal(false, ''));
                } else {
                    dispatch(addCommunitySensorError(`Error: ${res.status} ${res.statusText}`));
                    dispatch(toggleModal(false, ''));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
}
